import React from 'react';
import Main from './components/Main';

import "./App.css";
function App() {
  return (
     <div>
      <Main/>
     </div>
  );
}

export default App;
